import React, { FC } from 'react'
import { Box, FormControlLabel, Checkbox, CheckboxProps } from '@mui/material'

interface IProps extends CheckboxProps {
  marginTop?: number
  label?: string
  checked?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
}

const CustomCheckbox: FC<IProps> = ({
  marginTop,
  label,
  checked,
  onChange,
  className,
  ...props
}) => {
  return (
    <Box marginTop={marginTop} className={className}>
      <FormControlLabel
        control={
          <Checkbox
            color="primary"
            checked={checked}
            onChange={onChange}
            {...props}
          />
        }
        label={label}
      />
    </Box>
  )
}
export default CustomCheckbox
